<template>
  <ConfirmationModal
    v-if="showModal"
    @cancel="termsModalToggle"
    @confirmed="confirmTerms"
  >
    <div slot="body">
      <div class="field-container terms d-flex">
        <el-checkbox class="el-checkbox" @change="setConfirmationStatus"></el-checkbox>
        <label class="d-flex" :style="{color: 'black'}">
          {{ $t('payment.accept_terms_and_conditions') }}
        </label>
        <a :href="this.termsUrl" target="_blank" class="icon icon-info"></a>
      </div>
    </div>
  </ConfirmationModal>
</template>

<script>

import ConfirmationModal from "../../common/ConfirmationModal";
import moment from "moment/moment";
import {mapGetters} from "vuex";

export default {
  components: {
    ConfirmationModal
  },
  props: ['showTermsModal'],
  data() {
    return {
      showModal: false,
      termsConfirmed: false
    }
  },
  watch: {
    showTermsModal: function () {
      this.showModal = true
    }
  },
  computed: {
    ...mapGetters({
      users: 'users/user/user'
    }),
    termsUrl: {
      get() {
        return process.env[`TERMS_URL_${moment.locale().toUpperCase()}`]
      }
    }
  },
  methods: {
    termsModalToggle() {
      this.showModal = this.showModal !== true
    },
    confirmTerms() {
      if (!this.termsConfirmed) {
        return
      }
      this.registerCard()
    },
    setConfirmationStatus(e) {
      this.termsConfirmed = e !== false
    },
    registerCard() {
      const icuLocale = process.env.ICU_LOCALE[moment.locale()]
        ? process.env.ICU_LOCALE[moment.locale()]
        : process.env.ICU_LOCALE[process.env.DEFAULT_LANGUAGE]

      window.location.href = `${process.env.BACKEND_API_URL}payment/cards/register` +
        `?return_url=${process.env.BASE_URL}payment/register/result` +
        `&name=${this.users.name}` +
        `&language=${icuLocale}` +
        `&token=${localStorage.getItem('id_token')}`
    },
  }
}
</script>

<style lang="scss" scoped>

@import '~styles/app.scss';
@import '../assets/styles/payment';

</style>



// WEBPACK FOOTER //
// src/components/payment/ui/TermsModal.vue